import React, {Component} from 'react';
import {connect} from 'react-redux';
import {isEqual} from 'lodash';
import {Card, Grid, Dropdown, Button, Icon} from 'semantic-ui-react';
import FiltersSectionMultiple from '../../../common/components/dateFilterMultiple/dateFiltersSectionMultiple';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {dealerList} from '../../../common/constants/lists';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import DataTable from './dataTable';
import {getDropdownOptions} from '../../../common/util/dropdown';

const years = [{
  'year': 2019,
}, {
  'year': 2020,
}, {
  'year': 2021,
}, {
  'year': 2022,
}, {
  'year': 2023,
}, {
  'year': 2024,
}, {
  'year': 2025,
}, {
  'year': 2026,
}];

const typesList = [
  {'type': 'EXONERADO', 'value': 'E'},
  {'type': 'NORMAL', 'value': 'N'},
  {'type': 'TODOS', 'value': 'all'},
];

class DailyVehiclesSalesAndStockSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'clientTmp': 'all',
      'clientSelected': 'all',
      'dateFilters': {},
      'clearFilters': {
        'year': false,
        'month': false,
        'day': false,
      },
      'typeTmp': 'N',
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.DailyVehiclesSalesAndStockSummary,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {dateFilters, clientSelected, typeTmp} = this.state;
    if (!isEqual(prevState.dateFilters, dateFilters)) {
      this.onSearchClick();
    }
    if (!isEqual(prevState.clientSelected, clientSelected)) {
      this.onSearchClick();
    }
    if (!isEqual(prevState.typeTmp, typeTmp)) {
      this.onSearchClick();
    }
  }

  onDownloadClick = () => {
    const filters = this.getFilters();
    this.props.downloadDailyVehiclesSalesAndStockSummary(filters);
  };

  onSearchClick = () => {
    const filters = this.getFilters();
    this.props.fetchDailyVehiclesSalesAndStockSummary(filters);
  };

  getFilters = () => {
    const {clientSelected, dateFilters, typeTmp} = this.state;
    const filters = {};

    if (clientSelected && clientSelected !== 'all') {
      filters.clientId = clientSelected;
    }
    if (dateFilters) {
      filters.startDate = dateFilters.startDate;
      filters.endDate = dateFilters.endDate;
    }
    if (typeTmp && typeTmp !== 'all') {
      filters.salesType = typeTmp;
    }
    return filters;
  };

  updateSearchFilters = (value, filterName) => {
    const newState = {};
    newState[filterName] = value;
    this.setState(newState, () => this.updateDataForClient());
  };

  updateDataForClient = () => {
    const {clientSelected, clientTmp} = this.state;
    if (clientSelected === clientTmp) {
      return;
    }
    this.updateSearchFilters(clientTmp, 'clientSelected');
  };

  onUpdateDateFiltersClick = (dateFilters) => {
    this.setState({
      dateFilters,
      'clearFilters': {
        'year': false,
        'month': false,
        'day': false,
      },
    });
  };

  render() {
    const {clearFilters, clientTmp, clientSelected, typeTmp} = this.state;
    const {loading, downloading} = this.props;

    return (
      <div className='daily-vehicles-sales-and-stock-summary'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Resumen Ventas y Stock diario de Vehículos</h2>
              <div className='title-bar-actions'>
                <Button
                  primary
                  className='download'
                  disabled={loading || downloading}
                  loading={downloading}
                  onClick={this.onDownloadClick}
                >
                  <Icon name='download' />
                  <span>Excel</span>
                </Button>
                <Button
                  type='button'
                  primary
                  className='toyota-primary'
                  disabled={loading || downloading}
                  loading={loading}
                  onClick={this.onSearchClick}
                >
                  Buscar
                </Button>
              </div>
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={1} textAlign='right'>
                    <h4>Cliente:</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Dropdown
                      selection
                      options={dealerList}
                      search
                      value={clientTmp}
                      disabled={loading || downloading}
                      onChange={(e, {value}) =>
                        this.updateSearchFilters(value, 'clientTmp')
                      }
                      placeholder='Clientes'
                      noResultsMessage='Cliente no encontrado'
                    />
                  </Grid.Column>
                  <Grid.Column width={1} textAlign='right'>
                    <h4>Tipo:</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Dropdown
                      selection
                      options={getDropdownOptions(typesList, 'value', 'type')}
                      search
                      value={typeTmp}
                      disabled={loading || downloading}
                      onChange={(e, {value}) =>
                        this.updateSearchFilters(value, 'typeTmp')
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row textAlign='center'>
                  <Grid.Column width={16}>
                    <FiltersSectionMultiple
                      years={years}
                      clearFilters={clearFilters}
                      onDateFiltersClick={this.onUpdateDateFiltersClick}
                      showDays={true}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        <DataTable dealerSelected={clientSelected} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.dailyVehiclesSalesAndStockSummary.loading,
    'downloading': state.dailyVehiclesSalesAndStockSummary.downloading,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchDailyVehiclesSalesAndStockSummary,
  downloadDailyVehiclesSalesAndStockSummary,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchDailyVehiclesSalesAndStockSummary,
  downloadDailyVehiclesSalesAndStockSummary,
})(DailyVehiclesSalesAndStockSummary);
